import tourConfig from '../common/tour/config';

const tourSteps = (language) => {
  let tourOptions = tourConfig.getOptions(language);
  tourOptions.steps = [
    {
      element: '#alertCurveDayHeader',
      intro: language.tour.driverFatigueTour.dayColumn,
      position: 'right'
    },
    {
      element: '#scaleLegendWrapper',
      intro: language.tour.driverFatigueTour.legendAlert,
      position: 'right'
    },
    {
      element: '#sleepLegendWrapper',
      intro: language.tour.driverFatigueTour.legendSleep,
      position: 'left'
    },
    {
      element: '#alertCurveExtraIndicator2Header',
      intro: language.tour.driverFatigueTour.analysis,
      position: 'left'
    },
    {
      element: '#alertCurveExtraIndicatorHeader',
      intro: language.tour.driverFatigueTour.nfa,
      position: 'left'
    },
    {
      element: '#alertCurveHoursHeader',
      intro: language.tour.driverFatigueTour.hoursColumn,
      position: 'top'
    },
    {
      element: '#showAlertGraphButton',
      intro: language.tour.driverFatigueTour.showAlertGraphButton,
      position: 'top'
    }
  ];

  return tourOptions;
};

export default tourSteps;



// WEBPACK FOOTER //
// ./source/client/components/driver_fatigue/tourSteps.js